import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full h-full px-[12px] py-[12px]" }
const _hoisted_2 = { class: "search flex items-center gap-8px mb-12px" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "source-ref" }
const _hoisted_5 = { class: "source-text" }
const _hoisted_6 = { class: "source-content" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "cont" }
const _hoisted_9 = {
  key: 0,
  class: "listcont"
}
const _hoisted_10 = {
  key: 0,
  class: "listcont"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = {
  key: 0,
  class: "more-wrap"
}
const _hoisted_14 = {
  key: 1,
  class: "more-wrap"
}

import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { ElInput, ElPopover, ElIcon, ElButton, ElSkeleton, ElSkeletonItem, ElEmpty } from 'element-plus'
import { Search, ArrowDown, Collection, Link, Select } from '@element-plus/icons-vue'
import { on as busOn, off as busOff, getLast } from '@/utils/eventBus'
import { getMaterialSources, searchMaterialSources } from '@/api/affairs'
// @ts-ignore
import imageSearchItem from './imageSearchItem.vue'
import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'imageSearch',
  setup(__props) {

const userStore = useUserStore()
const query = ref('')
const canPreview = ref(false)
const imageSrc = computed(() => {
    const v = typeof query.value === 'string' ? query.value.trim() : ''
    return canPreview.value ? v : ''
})
const exts = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg', 'bmp']

let loader: HTMLImageElement | null = null
watch(query, (val) => {
    const s = typeof val === 'string' ? val.trim() : ''


    if (!s) { canPreview.value = false; loader = null; return }
    // if (!looksLikeImageUrl(s)) { canPreview.value = false; loader = null; return }

    const img = new Image()
    loader = img
    try { img.crossOrigin = 'anonymous' } catch { }
    img.onload = () => { if (loader === img) canPreview.value = true }
    img.onerror = () => { if (loader === img) canPreview.value = false }
    img.src = s
}, { immediate: true })

const handleSetURL = (url: any) => {
    if (typeof url === 'string') {
        query.value = url
    } else {
        query.value = String(url ?? '')
    }
    getSourceList()
}
onMounted(() => {
    busOn('imageSearch:setURL', handleSetURL)
    getSourceList()
    const last = getLast('imageSearch:setURL')
    handleSetURL(last)

})
onBeforeUnmount(() => {
    busOff('imageSearch:setURL', handleSetURL)
})
const defaultSource = ref<any>({})
const sourceVisible = ref(false)
const sourceList = ref<any[]>([])
const getSourceList = () => {
    getMaterialSources({}).then((res) => {
        sourceList.value = res.data.data || []
        defaultSource.value = sourceList.value[0]
        currentPage.value = 1
        search()
    })
}
const selectSource = (item: any) => {
    if (searchLoading.value || loadingMore.value) return
    defaultSource.value = item
    sourceVisible.value = false
    currentPage.value = 1
    search()
}
const searchResultList = ref<any[]>([])
const searchLoading = ref(false)
const loadingMore = ref(false)
const pageSize = ref(30)
const currentPage = ref(1)
const lastCount = ref(0)
const showMore = computed(() => lastCount.value === pageSize.value)
const searchimg = () => {
    currentPage.value = 1
    search(false)
}
const search = (next = false) => {

    if (searchLoading.value || loadingMore.value) return
    if (next) {
        loadingMore.value = true
    } else {
        searchLoading.value = true
    }
    currentPage.value = next ? currentPage.value + 1 : 1
    searchMaterialSources({
        file: query.value,
        id: defaultSource.value.id,
        page: currentPage.value,
        pageSize: pageSize.value,
        corp_code: userStore.currentTeamInfo?.corp_id || '',
    }).then((res) => {
        const list = res.data?.data?.list || []
        lastCount.value = list.length
        if (next) {
            searchResultList.value = (searchResultList.value || []).concat(list)
        } else {
            searchResultList.value = list
        }
    }).finally(() => {
        if (next) {
            loadingMore.value = false
        } else {
            searchLoading.value = false
        }
    })
}
const onMore = () => search(true)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElInput), {
        modelValue: query.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
        placeholder: canPreview.value ? '' : '输入文字或粘贴图片链接',
        clearable: "",
        class: _normalizeClass(canPreview.value ? 'show-image' : '')
      }, {
        prefix: _withCtx(() => [
          (canPreview.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: imageSrc.value,
                class: "input-thumb"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createBlock(_unref(ElIcon), { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Search))
                ]),
                _: 1
              }))
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder", "class"]),
      _createVNode(_unref(ElButton), {
        type: "primary",
        onClick: searchimg
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("搜索", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(_unref(ElPopover), {
      placement: "bottom-start",
      width: 220,
      trigger: "click",
      "show-arrow": false,
      visible: sourceVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((sourceVisible).value = $event))
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(ElIcon), { class: "mr-6px" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Collection))
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_5, _toDisplayString(defaultSource.value?.name || '素材源'), 1),
          _createVNode(_unref(ElIcon), { class: "caret" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowDown))
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["source-item", { active: defaultSource.value?.id === item.id }]),
              key: item.id,
              onClick: ($event: any) => (selectSource(item))
            }, [
              _createElementVNode("span", null, _toDisplayString(item.name), 1),
              (defaultSource.value?.id === item.id)
                ? (_openBlock(), _createBlock(_unref(ElIcon), { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Select), { color: "#2a66ff" })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 10, _hoisted_7))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", _hoisted_8, [
      (searchLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(30, (n) => {
              return _createElementVNode("div", {
                class: "listitem",
                key: 'sk-' + n
              }, [
                _createVNode(_unref(ElSkeleton), { animated: "" }, {
                  template: _withCtx(() => [
                    _createVNode(_unref(ElSkeletonItem), {
                      variant: "image",
                      class: "skeleton-img"
                    })
                  ]),
                  _: 1
                })
              ])
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (searchResultList.value && searchResultList.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResultList.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "listitem",
                      key: item.id
                    }, [
                      _createVNode(imageSearchItem, { template: item }, null, 8, ["template"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_unref(ElEmpty), { description: "暂无搜索结果" })
                ])),
            _createElementVNode("div", _hoisted_12, [
              (showMore.value && !loadingMore.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: "more-btn",
                      onClick: onMore
                    }, "更多")
                  ]))
                : (loadingMore.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("div", { class: "more-loading" }, "加载中...", -1)
                    ]))]))
                  : _createCommentVNode("", true)
            ])
          ], 64))
    ])
  ]))
}
}

})